import { Dispatch, Fragment, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '@/hooks/useRedux';
import { useSearchParams } from 'react-router-dom';
import { AnyAction } from 'redux';
import { RootState } from '@/store/index';
import { Field, Form, Formik } from 'formik';
import usersSlice from '../../store/slice/users.slice';
import Button from '@/components/Button/Button';
import CloseIcon from '@/src/assets/images/svg/close_icon.svg';

const EditExpiryDate = (): JSX.Element => {
  const dispatch: Dispatch<AnyAction> = useAppDispatch();
  const [searchParams] = useSearchParams();
  const formikRef: any = useRef();
  const id = searchParams.get('id');

  const { userDetails, isUpdateTrialSubscriptionLoading } = useAppSelector(
    (state: RootState) => state.users
  );

  const formatDate = (dateString: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  };

  const initialValues = {
    expiry_date: formatDate(
      userDetails ? userDetails.organization_subscription.ends_at : ''
    ),
  };

  const handleSubmit = async (values: typeof initialValues): Promise<void> => {
    if (id) {
      console.log(id);
      dispatch(
        usersSlice.actions.updateTrialSubscriptionExpiry({
          updateTrialBody: {
            end_date: values.expiry_date,
            s_subscription_id:
              userDetails?.organization_subscription?.s_subscription_id,
          },
          user_id: id,
        })
      );
    }
  };

  return (
    <Fragment>
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        {({ handleBlur, handleChange, values }): JSX.Element => (
          <Form>
            <div className="relative overflow-auto rounded-lg bg-white text-left shadow-xl transition-all w-[443px]">
              <div className="relative rounded-t-lg bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 ">
                <div
                  className="flex justify-end"
                  onClick={() => {
                    dispatch(
                      usersSlice.actions.setIsUpdateTrialSubscriptionModalOpen(
                        false
                      )
                    );
                  }}
                >
                  <img src={CloseIcon} alt="" className="cursor-pointer" />
                </div>
                <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                  <h3 className="text-xl font-semibold leading-6 text-black-dark-color">
                    Edit Expiry Date
                  </h3>
                  <div className="text-black text-xs mt-1 leading-2 pt-3">
                    Update the trial subscription expiry date.
                  </div>
                </div>
              </div>
              <div className="flex flex-col px-4 pb-4 pt-0 sm:px-6 sm:pb-4">
                <label
                  htmlFor="expiry_date"
                  className="text-xs font-semibold text-gray-700 ps-1 pb-1"
                >
                  Expiry Date
                </label>
                <Field
                  type="date"
                  name="expiry_date"
                  label="Expiry Date"
                  className="border-[0.3px] border-grey-black-color px-4 py-1 rounded-sm cursor-pointer text-sm"
                  value={formatDate(values.expiry_date)}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  min={
                    userDetails?.organization_subscription?.ends_at?.split(
                      'T'
                    )[0]
                  }
                />
              </div>
              <div className="bg-gray-50 px-4 pt-2 pb-6 flex sm:px-6 w-full">
                <Button
                  text="Cancel"
                  onClick={() => {
                    dispatch(
                      usersSlice.actions.setIsUpdateTrialSubscriptionModalOpen(
                        false
                      )
                    );
                  }}
                  className="inline-flex w-1/2 mr-3 h-46 border border-grey-light-color hover:border-red-error-color hover:text-red-error-color justify-center items-center text-inter-black text-sm rounded-sm"
                />
                <Button
                  text="Update Expiry Date"
                  type="submit"
                  disabled={isUpdateTrialSubscriptionLoading}
                  isLoading={isUpdateTrialSubscriptionLoading}
                  className="inline-flex w-1/2 ml-3 h-46 border border-button-light-green hover:bg-white hover:text-button-light-green bg-button-light-green justify-center items-center text-white text-sm rounded"
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Fragment>
  );
};

export default EditExpiryDate;
